import React, {useState, useEffect} from "react"
import {manufacturerService} from "../Services/manufacturerService";
import {Divider, Drawer, Select, Spin} from "antd";
import {Manufacturer} from "../types/Manufacturer";
import {useTranslation} from "react-i18next";
import {PlusOutlined} from "@ant-design/icons";
import UnitOfMeasureForm from "../Pages/UnitOfMeasure/unitOfMeasureForm";
import ManufacturerForm from "../Pages/Manufacturer/manufacturerForm";

interface ManufacturerSelectProps {
    defaultSelected? : string
    afterSelect? : (v:string)=>void;
}

const ManufacturerSelect=({defaultSelected, afterSelect}: ManufacturerSelectProps)=>{


    const [manufacturer, setManufacturers ]=useState<Manufacturer[]|undefined>()
    const [loading, setLoading] = useState<boolean>(true);
    const [selectedValue, setSelectedValue] = useState(defaultSelected);


    const [open, setOpen] = useState(false);
    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };
    

    const {t}=useTranslation();

    useEffect(() => {
        const fetchManufacturers = async () => {
            setLoading(true);
            try {
                const response = await manufacturerService.getAll();
                setManufacturers(response);
            } catch (error) {
                console.error('Ошибка при получении производителей:', error);
            } finally {
                setLoading(false);
            }
        };
        setSelectedValue(defaultSelected)
        fetchManufacturers();
    }, [defaultSelected]);

    const handleSelect=(value: string)=>{
        setSelectedValue(value)
        if(afterSelect){
            afterSelect(value)
        }
    }

    const handleCreated = (v?: any) =>{
        setOpen(false);
        if(v){
            manufacturer?.push(v);
            setSelectedValue(v.id);
            if(afterSelect){
                afterSelect(v.id)
            }
            console.log("handleCreated: ", v);
        }


    }

    return <Spin spinning={loading}>
        <Select
            allowClear={true}
            showSearch={true}
            style={{width: "100%"}} placeholder={t("Select_a_supplier")}
            value={selectedValue}
            options={manufacturer?.map((prod)=>({label: prod.name, value: prod.id, code: prod.code}))}


            filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())||
                (option?.code ?? '').toLowerCase().includes(input.toLowerCase())
            }



            optionRender={(option) => (<div>
                <span style={{fontSize: "10px", color: "#999"}}>{option.data.code}</span><br/>
                <span>{option.data.label}</span>
            </div>)}

            dropdownRender={(menu) => (
                <>
                    {menu}
                    <Divider style={{ margin: '8px 0' }} />
                    <div style={{ padding: '5px', width: "100%", cursor: "pointer" }}

                         onClick={showDrawer}> <PlusOutlined /> {t("Add_new_manufacturer")}
                        {/*  <Button type="text" icon={<PlusOutlined />} onClick={showDrawer}>
                            Add item
                        </Button>*/}
                    </div>
                </>
            )}


            onChange={handleSelect}

        />

        <Drawer 
            destroyOnClose={true}
            title={<p><b>{t('Add_new_manufacturer')}</b></p>} onClose={onClose} open={open}>
            <ManufacturerForm
                closeEmbeded={(v)=> {
                    handleCreated(v)
                }}
                embeddedCreate={true} />
        </Drawer>
    </Spin>



}
export default ManufacturerSelect